import script from "./UserProfilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfilePage.vue?vue&type=script&setup=true&lang=js"

import "./UserProfilePage.vue?vue&type=style&index=0&id=3efbecd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3efbecd8"]])

export default __exports__